<template>
    <div id="dataSource">
       <a-row type="flex" justify="start" class="mt">
           <a-col>
               <a-form :form="form">
                   <a-form-item label="Data Source Name" v-bind="formItemLayout">
                       <a-select
                               allowClear
                               style="width: 240px"
                               size="small"
                               v-decorator="[
                          'rtSqlUid',{ rules: [{ required: true, message: $t('publicLang.Required')}]}
                          ]">
                           <a-select-option v-for="item in dataSourceList" :value="item.uid">{{item.dsName}}</a-select-option>
                       </a-select>
                   </a-form-item>

               </a-form>
           </a-col>
           <a-col class="ml4">
               <a-tooltip placement="topLeft">
                   <template slot="title">
                       <span>{{ $t('generic.Add') }}</span>
                   </template>
                   <img @click="addDataSource" class="sbxs" src="../../../../assets/img/ss-add.png" width="22" height="22">
               </a-tooltip>
           </a-col>
           <a-col class="ml4">
               <a-popconfirm
                       :title="$t('generic.AreyoudeleTask')"
                       @confirm="delDataSource"
                       :okText="$t('generic.Yes')"
                       :cancelText="$t('generic.No')"
               >
                   <a-tooltip placement="topLeft">
                       <template slot="title">
                           <span>{{$t('pubGicSet.Remove')}}</span>
                       </template>
                       <img class="sbxs" src="../../../../assets/img/ss-delete.png" width="22" height="22">
                   </a-tooltip>
               </a-popconfirm>
           </a-col>


       </a-row>
        <a-row>
            <vxe-table
                    border
                    resizable
                    highlight-hover-row
                    size="mini"
                    :data="tableData"
                    ref="dataSouceTableRef">
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="dsName" title="Data Srouce Name" minWidth="150"></vxe-table-column>
            </vxe-table>
        </a-row>
    </div>
</template>
<script>
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    export default{
        props:{
            dataSourceRow: {
                type: Object,
                default: function() {
                    return {};
                }
            },
            headerUid:{
                type: String,
                default: function() {
                    return '';
                }
            }
        },
        data(){
            return{
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                form:this.$form.createForm(this),
                tableData: [],
                dataSourceList:[],
                dataSourceName: null,
            }
        },
        watch:{
            dataSourceRow(v){
                this.init()
            }
        },
        created(){
            this.init()
        },
        methods:{
            init(){
                ajax.get(api.REPORTGENERICCONFIGIREPORTDS,{rtIreportUid:  this.dataSourceRow.uid}).then(res=>{
                    this.tableData = res.data
                })
                ajax.get(api.REPORTGENERICCONFIGDATASOURCE,{rtMasterUid: this.headerUid}).then(res=>{
                    this.dataSourceList = res.data
                })
            },
            addDataSource(){
                this.form.validateFields((err,values)=>{
                    if(!err){
                        values.rtIreportUid = this.dataSourceRow.uid
                        ajax.post(api.REPORTGENERICCONFIGIREPORTDS,values).then(res=>{
                            if(res.code == 200){
                                this.$message.success(res.msg);
                                this.init()
                                this.form.resetFields();
                            }else{
                                this.$customMessage.warning(res.msg);
                            }
                        })
                    }
                })

            },
            delDataSource(){
                let arr = this.$refs.dataSouceTableRef.getCheckboxRecords()
                if(arr.length > 0){
                    let params = {uids: []}
                    for(let i in arr){params.uids.push(arr[i].uid)}
                    ajax.post(api.REPORTGENERICDELCONFIGIREPORTDS,params).then(res=>{
                        if(res.code == 200){
                            this.init()
                        }
                    })
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'))
                }
            }
        }
    }
</script>